import Product from './Product';
import Box from './Box';

class FBAShipment {
  constructor(data) {
    this.id = data.id || null;
    this.client_comment = data.client_comment || '';
    this.first_name = data.first_name || '';
    this.last_name = data.last_name || '';
    this.country = data.country || '';
    this.state = data.state || '';
    this.city = data.city || '';
    this.address = data.address || '';
    this.postcode = data.postcode || '';
    this.phone = data.phone || '';
    this.fba_id = data.fba_id || null;
    this.type = data.type || null;
    this.user_id = data.user_id || null;
    this.tracking_code = data.tracking_code || '';
    this.printed = data.printed || null;
    this.created_at = data.created_at || null;

    this.fnsku_labels = data.fnsku_labels || data.fnsku_label || null;
    this.shipping_labels = data.shipping_labels || data.shipping_label || null;
    this.pallet_labels = data.pallet_labels || data.pallet_label || null;
    this.fbm_label = data.fbm_labels || data.fbm_label || null;

    this.boxes = [];
    if (data && typeof data.boxes !== 'undefined') {
      for (const item of data.boxes) {
        this.boxes.push(new Box(item));
      }
    }

    this.products = [];
    if (data && typeof data.products !== 'undefined') {
      for (const item of data.products) {
        this.products.push(new Product(item));
      }
    }
  }
}

export default FBAShipment;
